import React from 'react';

const Footer = () => (
  <footer className="bg-dark text-white text-center p-3">
    <p>&copy; 2025 AZBOT APP. All rights reserved.</p>
  </footer>
);

export default Footer;
